import React from 'react';
import { PhoneIcon, FileSearchIcon, MessagesSquareIcon, ClipboardListIcon, ScaleIcon, BoxIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 08 — HOW IT WORKS · [Journey] [Trust] [Conversion]
// Five steps. Guidance-line connects steps. No promise of outcome.
// processSteps{step,title,description,icon}
const processSteps = [{
  step: 1,
  title: 'Tell us what happened',
  description: 'Start with a confidential conversation. You do not need documents or legal terms — just what you remember.',
  icon: 'phone'
}, {
  step: 2,
  title: 'We review the circumstances',
  description: 'We look at how the injury happened, when it happened and the law that applies to your situation.',
  icon: 'review'
}, {
  step: 3,
  title: 'We explain the available options',
  description: 'You get a clear, plain-English explanation of your rights and the paths that may be open to you.',
  icon: 'explain'
}, {
  step: 4,
  title: 'We gather evidence and manage the claim',
  description: 'We organise medical and factual evidence and handle the process so you can focus on recovery.',
  icon: 'clipboard'
}, {
  step: 5,
  title: 'We negotiate or litigate where required',
  description: 'We work towards a resolution and are prepared to litigate when that is the right course for your claim.',
  icon: 'scale'
}];
const stepIcons: Record<string, BoxIcon> = {
  phone: PhoneIcon,
  review: FileSearchIcon,
  explain: MessagesSquareIcon,
  clipboard: ClipboardListIcon,
  scale: ScaleIcon
};
export function ProcessSection() {
  return <Section id="how-it-works" className="bg-forest text-paper" data-id="element-241">
      <SectionHeading tone="dark" eyebrow="How it works" title="A Clear Path From First Call to Resolution" intro="Five steps, explained plainly. Every claim is different, but the way we guide you stays consistent." data-id="element-242" />

      <ol className="mt-12 space-y-2" data-id="element-243">
        {processSteps.map((s, i) => {
        const Icon = stepIcons[s.icon];
        const isLast = i === processSteps.length - 1;
        return <li key={s.step} className="relative flex gap-5 pb-8 last:pb-0" data-id="element-244">
              {/* Guidance line connecting the steps */}
              {!isLast && <span aria-hidden="true" className="absolute left-6 top-12 h-[calc(100%-3rem)] w-px bg-paper/15" data-id="element-245" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold text-forest-700 shadow-[0_8px_24px_-10px_rgba(192,138,45,0.9)]" data-id="element-246">
                <Icon aria-hidden={true} className="h-5 w-5" strokeWidth={1.75} data-id="element-247" />
              </span>
              <div className="pt-1.5" data-id="element-248">
                <div className="flex items-center gap-3" data-id="element-249">
                  <span className="text-small font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-250">
                    Step {s.step}
                  </span>
                </div>
                <h3 className="mt-1 text-h4 font-semibold text-paper" data-id="element-251">
                  {s.title}
                </h3>
                <p className="mt-1.5 max-w-2xl text-body text-paper/70" data-id="element-252">
                  {s.description}
                </p>
              </div>
            </li>;
      })}
      </ol>
    </Section>;
}